import { createSelector } from 'reselect';
import { showSelector } from 'ai/selectors/testTarget/welcomeMat/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showWelcomeMat = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showWelcomeMat };
